var React = require('react');

function TwitterWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.245,11.107c.024.339.024.678.024,1.017,0,10.341-7.871,22.257-22.257,22.257A22.106,22.106,0,0,1,0,30.869a16.183,16.183,0,0,0,1.889.1A15.666,15.666,0,0,0,11.6,27.624,7.836,7.836,0,0,1,4.287,22.2a9.865,9.865,0,0,0,1.477.121,8.274,8.274,0,0,0,2.059-.266A7.824,7.824,0,0,1,1.55,14.376v-.1a7.878,7.878,0,0,0,3.536.993A7.834,7.834,0,0,1,2.664,4.81,22.236,22.236,0,0,0,18.794,13,8.831,8.831,0,0,1,18.6,11.2,7.83,7.83,0,0,1,32.138,5.851,15.4,15.4,0,0,0,37.1,3.962a7.8,7.8,0,0,1-3.439,4.311,15.682,15.682,0,0,0,4.5-1.211,16.816,16.816,0,0,1-3.923,4.044Z","transform":"translate(0 -3.381)","fill":"#fff"}));
}

TwitterWhite.defaultProps = {"width":"38.169","height":"31","viewBox":"0 0 38.169 31"};

module.exports = TwitterWhite;

TwitterWhite.default = TwitterWhite;
